import { Component, Input, OnInit, Output, EventEmitter  } from '@angular/core';
import { TareaService } from '@src/app/services/tarea.service';
import { HttpErrorResponse } from '@angular/common/http';
import { CdkDragDrop, transferArrayItem, moveItemInArray } from '@angular/cdk/drag-drop';
import { Lista, Tarea } from '@src/app/interfaces/lista.model';
import { DetalleTareaComponent } from './modal/detalle-tarea.component'; // Asegúrate de tener este componente
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-lista',
  templateUrl: './lista.component.html',
})
export class ListaComponent implements OnInit {
  @Input() lista!: Lista;
  @Input() listasConectadas: string[] = [];
  @Output() refrescarListas = new EventEmitter<void>();


  usuario_id = 0;
  agregandoTarea = false;
  nuevoTitulo = '';

  constructor(private tareaService: TareaService, private dialog: MatDialog) { }

  ngOnInit(): void {
    try {
      const user = JSON.parse(localStorage.getItem('user') || '{}');
      this.usuario_id = parseInt(user.id);
    } catch (e) {
      console.warn('Usuario no válido en localStorage');
    }

    // Asegurar que siempre haya un arreglo de tareas
    if (!this.lista.tareas) {
      this.lista.tareas = [];
    }
  }

  abrirModalTarea(tarea: any): void {
  const dialogRef = this.dialog.open(DetalleTareaComponent, {
    maxWidth: '100vw',
    maxHeight: '90vh',
    height: 'auto',
    panelClass: 'dialog-full',
    data: tarea
  });

  dialogRef.afterClosed().subscribe((result: any) => {
    if (result === true) {
      console.log('🔁 Modal cerrado con éxito. Recargando listas...');
      this.refrescarListas.emit(); // ✅ recarga desde el servicio y actualiza this.listas
    }
  });
}


  mostrarInputTarea() {
    this.agregandoTarea = true;
  }

  cancelarTarea() {
    this.agregandoTarea = false;
    this.nuevoTitulo = '';
  }

  confirmarTarea() {
  const titulo = this.nuevoTitulo.trim();
  const tableroId = +localStorage.getItem('tableroId')!;

  if (!titulo || !this.lista.id || !this.usuario_id) {
    console.warn('Faltan datos necesarios');
    return;
  }


  const tareaData = {
    titulo,
    id_lista: this.lista.id,
    creado_por: this.usuario_id,
    tablero_id: tableroId  // 👈 lo incluyes aquí
  };

  this.tareaService.crearTarea(tareaData).subscribe({
    next: () => {
      this.lista.tareas.push({ id: Date.now().toString(), titulo });
      this.nuevoTitulo = '';
      this.agregandoTarea = false;
      this.refrescarListas.emit();
    },
    error: (err: HttpErrorResponse) => {
      console.error('Error al crear la tarea:', err);
    }
  });
}


  obtenerClaseEstado(valor?: string | number): string {
    if (typeof valor === 'string') {
      switch (valor) {
        case 'Por hacer': return 'bg-[#1976d2]';
        case 'En progreso': return 'bg-[#f57c00]';
        case 'Hecho': return 'bg-[#388e3c]';
        default: return 'bg-[#90a4ae]';
      }
    }
    if (typeof valor === 'number') {
      switch (valor) {
        case 1: return 'bg-[#876d1e]';
        case 2: return 'bg-[#f57c00]';
        case 3: return 'bg-[#388e3c]';
        default: return 'bg-[#90a4ae]';
      }
    }
    return 'bg-[#90a4ae]';
  }

  moverTarea(event: CdkDragDrop<Tarea[]>) {
    console.log('Evento Drop:', event);

    const mismaLista = event.previousContainer === event.container;

    if (mismaLista) {
      moveItemInArray(this.lista.tareas, event.previousIndex, event.currentIndex);
    } else {
      const tarea = event.previousContainer.data[event.previousIndex];
      console.log('Moviendo tarea:', tarea);

      transferArrayItem(
        event.previousContainer.data,
        event.container.data,
        event.previousIndex,
        event.currentIndex
      );

      this.tareaService.actualizarListaTarea({
        tarea_id: tarea.id,
        nueva_lista_id: event.container.id,
        lista_origen_id: event.previousContainer.id,
        usuario_id: this.usuario_id
      }).subscribe({
        next: () => console.log('✅ Tarea actualizada en el backend'),
        error: (err) => console.error('❌ Error al actualizar tarea:', err)
      });
    }
  }



}
